import { SelectionMode } from "@fluentui/react";
import { DataLoadMode, IObjectPickerModalOptions } from "@cayo/shared/api/types/schema";

// #32867 TODO: delete this file when ui-scheme will provide these values
const searchScopes = [
  {
    name: "AD Computers",
    columns: [
      {
        displayName: "Name",
        key: "Name",
        fieldName: "Name",
        columnActionsMode: "disabled",
      },
      {
        displayName: "Description",
        key: "Description",
        fieldName: "Description",
        columnActionsMode: "disabled",
      },
      {
        displayName: "DNS Host Name",
        key: "DNSHostName",
        fieldName: "DNSHostName",
        columnActionsMode: "disabled",
      },
      {
        displayName: "Parent OU",
        key: "ParentOU",
        fieldName: "ParentOU",
        columnActionsMode: "disabled",
      },
    ],
    path: "/v1.0/objectpickers/00000000-0000-0000-0000-000000000007/execute2",
    body: {
      parameters: [
        {
          name: "CayoTargetFormActionCommandId",
          value: "a038fbb9-b3ed-4875-870c-6609b6354173",
        },
        {
          name: "CayoTargetFormPropertyId",
          value: "TrustedServices",
        },
        {
          name: "CayoSelectedObjectsIds",
          value:
            "X9zFe4hYBIrwP9gO2UR0HukxupELueAT0UI4nlnAnXUOYOS6njf26kL6VD22U918Wuux+sOlGg2IXL5YQTd+N3zTEI8Wwn+/ZE//cJVIfe+L07kwqUDl8pqPmbLuJK2PlLWABzRgHCiYIPOpc20sKpwl0buxvLS1o3gkUsj62boqMXXw/EtmRlYrraRDLBx9I/87eiKGS5ArzaMTf2XHbw==",
        },
        {
          name: "CayoWebViewId",
          value: "4fbabb4b-f3be-4408-b91f-bca2d55492ad",
        },
        {
          name: "CayoWebMaxResults",
          value: "20",
        },
        {
          name: "CayoTag",
          value: "not_empty_spn_filter",
        },
      ],
    },
  },
  {
    name: "AD Users",
    columns: [
      {
        displayName: "State",
        key: "State",
        fieldName: "State",
        columnActionsMode: "disabled",
      },
      {
        displayName: "Display Name",
        key: "DisplayName",
        fieldName: "DisplayName",
        columnActionsMode: "disabled",
      },
      {
        displayName: "UserPrincipalName",
        key: "UserPrincipalName",
        fieldName: "UserPrincipalName",
        columnActionsMode: "disabled",
      },
      {
        displayName: "Description",
        key: "Description",
        fieldName: "Description",
        columnActionsMode: "disabled",
      },
      {
        displayName: "Parent OU",
        key: "ParentOU",
        fieldName: "ParentOU",
        columnActionsMode: "disabled",
      },
    ],
    path: "/v1.0/objectpickers/00000000-0000-0000-0000-000000000002/execute2",
    body: {
      parameters: [
        {
          name: "CayoTargetFormActionCommandId",
          value: "a038fbb9-b3ed-4875-870c-6609b6354173",
        },
        {
          name: "CayoTargetFormPropertyId",
          value: "TrustedServices",
        },
        {
          name: "CayoSelectedObjectsIds",
          value:
            "X9zFe4hYBIrwP9gO2UR0HukxupELueAT0UI4nlnAnXUOYOS6njf26kL6VD22U918Wuux+sOlGg2IXL5YQTd+N3zTEI8Wwn+/ZE//cJVIfe+L07kwqUDl8pqPmbLuJK2PlLWABzRgHCiYIPOpc20sKpwl0buxvLS1o3gkUsj62boqMXXw/EtmRlYrraRDLBx9I/87eiKGS5ArzaMTf2XHbw==",
        },
        {
          name: "CayoWebViewId",
          value: "4fbabb4b-f3be-4408-b91f-bca2d55492ad",
        },
        {
          name: "CayoWebMaxResults",
          value: "20",
        },
      ],
    },
  },
];

const modalOptions: IObjectPickerModalOptions = {
  title: "Select Object",
  description: "",
  dataLoadMode: DataLoadMode.OnSearch,
  selectionMode: SelectionMode.single,
};

const getServicesSearchScope = (cayoObjId: string) => [
  {
    name: "AD Computers",
    columns: [
      {
        displayName: "Service Type",
        key: "ServiceType",
        fieldName: "ServiceType",
        columnActionsMode: "disabled",
      },
      {
        displayName: "User Or Computer",
        key: "UserOrComputer",
        fieldName: "UserOrComputer",
        columnActionsMode: "disabled",
      },
      {
        displayName: "Port",
        key: "Port",
        fieldName: "Port",
        columnActionsMode: "disabled",
      },
      {
        displayName: "Instance",
        key: "Instance",
        fieldName: "Instance",
        columnActionsMode: "disabled",
      },
      {
        displayName: "Service Name",
        key: "ServiceName",
        fieldName: "ServiceName",
        columnActionsMode: "disabled",
      },
    ],
    path: "v1.0/webActions/a038fbb9-b3ed-4875-870c-6609b6354173/validate2",
    body: {
      parameters: [
        {
          name: "CayoTargetFormActionCommandId",
          value: "a038fbb9-b3ed-4875-870c-6609b6354173",
        },
        {
          name: "CayoSelectedObjectsIds",
          value: cayoObjId,
        },
        {
          name: "CayoWebViewId",
          value: "4fbabb4b-f3be-4408-b91f-bca2d55492ad",
        },
        {
          name: "CayoGetServicesBySPN",
          value: "true",
        },
      ],
    },
  },
];

const servicesColumns = [
  {
    displayName: "Service Type",
    key: "serviceType",
    fieldName: "serviceType",
    width: "25%",
    isSorted: true,
    isSortedDescending: false,
    columnActionsMode: "disabled",
  },
  {
    displayName: "User or Computer",
    key: "userOrComputer",
    fieldName: "userOrComputer",
    width: "25%",
    columnActionsMode: "disabled",
  },
  {
    displayName: "Port",
    key: "port",
    fieldName: "port",
    width: "15%",
    columnActionsMode: "disabled",
  },
  {
    displayName: "Instance",
    key: "instance",
    fieldName: "instance",
    width: "20%",
    columnActionsMode: "disabled",
  },
  {
    displayName: "Service Name",
    key: "serviceName",
    fieldName: "serviceName",
    width: "15%",
    columnActionsMode: "disabled",
  },
];

export const apiMocks = {
  searchScopes,
  modalOptions,
  getServicesSearchScope,
  servicesColumns,
};
